import LegalPage from "@/pages/LegalPage";
export default function Terms() {
  return <LegalPage tKey="terms" testId="terms-page" />;
}
